import { render, staticRenderFns } from "./emojiManage.vue?vue&type=template&id=2a71c89a&scoped=true&"
import script from "./emojiManage.vue?vue&type=script&lang=js&"
export * from "./emojiManage.vue?vue&type=script&lang=js&"
import style0 from "./emojiManage.vue?vue&type=style&index=0&id=2a71c89a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a71c89a",
  null
  
)

export default component.exports